const state = {
  login: false,
  menus: [],
  user: {app_user_id: 0, username: '未登录', type: 0, mobile: ''},
  all_users: [],
  crm_firm_info:{img:'',crm_firm_name:'',crm_firm_first_login:''},
  menu_list:[],
  child_menu_list:{},
  session_id:null,
  show_guide: false,
  power: {},
  show_modal_type:'crm',
  has_dms: false,
  has_dms_subscription: false,
  has_crm: false,
  open_structure: true
}

const mutations = {
  // 切换菜单模块
  setModalType(state,payload){
    state.show_modal_type = payload.show_modal_type
  },
  // 引导页
  setGuide(state,payload){
    state.show_guide = payload.show_guide
  },
  setLoginData(state,payload){
    if(payload.session_id){
      state.session_id = payload.session_id
      state.login = true
    }
    state.user = payload
  },
  userLogout (state, payload) {
    state.login = false
    state.session_id = null
    state.user = {app_user_id: 0, username: '未登录', type: 0, mobile: ''}
    state.crm_firm_info = {img:'',crm_firm_name:'',crm_firm_first_login:''}
    window.localStorage.removeItem("loginData")
  },
  setSessionId (state, payload) {
    state.session_id = payload.session_id
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js